// extracted by mini-css-extract-plugin
export default {"SuccessMessages":"SuccessMessages_SuccessMessages__UABDG"};